<template>
  <div class="medal-manager">
    <!-- 勋章配置表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      highlight-current-row=""
      style="width: 100%; margin-top: 20px"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      class="custom-padding-table"
    >
      <!--勋章类型 -->
      <el-table-column label="勋章类型" width="200">
        <template #default="scope">
          <span v-if="scope.row.medalType == '1'">学习勋章</span>
          <span v-else-if="scope.row.medalType == '2'">消费勋章</span>
          <span v-else-if="scope.row.medalType == '3'">拉新勋章</span>
          <span v-else-if="scope.row.medalType == '4'">分享勋章</span>
          <span v-else-if="scope.row.medalType == '5'">赚钱勋章</span>
          <span v-else-if="scope.row.medalType == '6'">答题勋章</span>
        </template>
      </el-table-column>
      <!-- 等级列 -->
      <el-table-column prop="grade" label="等级" width="200" />
      <!-- 勋章名称列 -->
      <el-table-column prop="medalName" label="勋章名称" width="200" />
      <!-- 获取条件列 -->
      <el-table-column
        v-if="filters.medalType == 1"
        label="获取条件 (看视频时长:x分钟)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 2"
        label="获取条件 (消费金额:元)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 3"
        label="获取条件 (拉新人数:个)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 4"
        label="获取条件 (分享有效点击:次)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 5"
        label="获取条件 (赚钱金额:元)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 6"
        label="获取条件 (答对题数:个)"
        prop="conditionValue"
      >
      </el-table-column>
      <!-- 材质列 -->
      <el-table-column prop="rankTexture" label="材质" width="80" />
      <!-- 勋章图片列 -->
      <el-table-column label="勋章图片">
        <template #default="scope">
          <el-image
            v-if="scope.row.medalImgUrl"
            :src="scope.row.medalImgUrl"
            fit="cover"
            style="width: 80px; height: 40px; margin: 0 auto"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" prop="updateTime"> </el-table-column>
      <el-table-column label="操作人" prop="updateUserName"> </el-table-column>
    </el-table>

    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import { getChangeMedalConfigurationListApi } from "../../../api/api";

export default {
  name: "MedalManager",
  data() {
    return {
      filters: {
        medalType: "",
        configurationMedalId: "",
      },
      // 勋章列表数据（初始化与图片一致）
      tableData: [],
      listLoading: false,
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
    };
  },

  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },

    getList() {
      let params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getChangeMedalConfigurationListApi(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.data;
          this.pages.dataCount = res.data.response.dataCount;
        }
      });
    },
  },
  mounted() {
    this.filters = {
      medalType: this.$route.query.medalType,
      configurationMedalId: this.$route.query.id,
    };
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>
.medal-manager {
  padding: 20px;
}

.avatar-uploader {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  /* margin: 0 auto; */
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c8c8c;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>